<template>
    
    <div class="login" name="login">
        <topNav :title="title"></topNav>
        <van-cell-group class="form_box">
            <div class="ipt ipt_phoneNumer">
                <i></i><van-field class="right_input" v-model="phonenumber" maxlength=11 clearable placeholder="请输入手机号" />
            </div>
            <div class="ipt ipt_password">
                <i></i><van-field v-model="password" type="password" clearable placeholder="请输入6-18位密码" />
            </div>
        </van-cell-group>
        
        <div class="btns">
            <van-button type="info" :loading="isLogin" loading-text="登录中..." @click="userLogin()">登录</van-button>
            <div class="other">
              <div class="register" @click='register'>注册</div>
              <div class="forgetPassword" @click='forgetPassword'>忘记密码</div>
            </div>
        </div>
    </div>
</template>

<script>
  import Vue from 'vue'
  import topNav from "../topnav/topnav";
  import { Field,Cell,CellGroup,Button,Toast } from 'vant';
  import {DETAIL as API} from "@/assets/api";

  export default {
    name: 'login',
    components:{
      topNav,
      Field,
      [Cell.name]:Cell,
      [CellGroup.name]:CellGroup,
      Button,
      Toast
    },
    data() {
      return {
        title:"登录",
        phonenumber: '',
        password: '',
        isLogin: false,
      }
    },
    mounted() {
      const object = this.$route.params;
      for (const key in object) {
        if (object.hasOwnProperty(key)) {
          this[key] = object[key];
        }
      }
    },
    methods:{
      userLogin(){
        let browserType = this.$store.state.browserType;
        if(browserType !== 'wx' && browserType !== 'al') {Toast('请用微信或者支付宝打开!');return}
        if(!this.commonUtil.validPhone(this.phonenumber)) return; //验证手机号
        if(!this.commonUtil.validPassword(this.password)) return; // 验证密码长度
        let originalId = this.$store.state.originalId;

        let req = {
          originalId: originalId,
          phonenumber: this.phonenumber,
          password: this.password,
          browserType: browserType
        }
        this.isLogin = true;
        this.$http({
            method: 'post',
            url: API.LOGIN,
            data: this.qs.stringify(req),
            success: function(res){
              if (res.code == 0) {
                this.commonUtil.delCookie('isUserLogOut')
                const expriyTimeStamp = new Date().getTime()+this.$store.state.indate*24*60*60*1000;
                this.$store.commit('setExpriyTimeStamp',expriyTimeStamp);
                
                this.commonUtil.updateUserInfo(this.phonenumber);//登录成功保存用户信息
                if (res.data.length && res.data.cars) { // 保存车辆信息
                  let cars = [];
                  if(res.data[0].cars) cars = res.data[0].cars;
                  this.$store.commit('getBindCars',cars);
                }
                let routerName = sessionStorage.getItem("routerName") || 'my';
                this.$router.replace({name:routerName});
              } else {
                this.$toast(res.msg);
                this.isLogin = false;
              }
            }.bind(this),
            error: function(error){
                console.log(error)
                this.isLogin = false;
            }
        })
        
      },
      register(){
        this.$router.push({ name: 'register', params: { phonenumber: this.phonenumber }})
      },
      forgetPassword(){
        this.$router.push({ name: 'forgetPassword', params: { phonenumber: this.phonenumber }})
      },
    },
    
  }
</script>
<style lang="less" scoped>
  .login{
    height: 100%;
  }
  .form_box{
    margin-bottom: 30px;
    .ipt{
      box-sizing: border-box;
      height: 44px;
      padding-left: 30px;
      position: relative;
      background-color: #fff;
      overflow: hidden;
      i{
        display: block;
        min-width: 1em;
        height: 24px;
        margin-right: 5px;
        position: absolute;
        left: 10px;
        top: 10px;
      }
      .van-cell{
        padding: 0 15px;
        line-height: 44px;
      }
      &.ipt_phoneNumer{
        border-bottom: 1px solid #eee;
        i{
          background: url('../../../static/images/icon_phone.png') center no-repeat;
          background-size: 100%;
        }
      }
      &.ipt_password{
        i{
          background: url('../../../static/images/icon_lock.png') center no-repeat;
          background-size: 100%;
        }
      }
    }
  }
  .btns{
    padding: 0 15px;
    .van-button{
      border-radius: 3px;
      outline: none;
      border: none;
      width: 100%;
      // height: 100%;
      background-color: #4687f8;
      color: #fff;
    }
    .other{
      line-height: 40px;
      font-size: 12px;
      color: #2c3e50;
      &:after{
        content: ' ';
        display: table;
        clear: both;
      }
    }
    .register{
      float: left;
      color: #2c3e50;
    }
    .forgetPassword{
      float: right;
      color: #2c3e50;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/my/login.vue